import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service, index = 0, onSelect }) {
  const Icon = service.icon;

  return (
    <button
      type="button"
      onClick={() => onSelect(service)}
      className={`service-card lift text-left p-7 sm:p-8 flex flex-col h-full group focus:outline-none focus:ring-2 focus:ring-[#FACC15]/60 ${
        service.featured ? "!border-[#FACC15] !bg-[#FACC15]/10" : ""
      }`}
      data-testid={`service-card-${service.slug}`}
      aria-label={`Scopri il servizio ${service.name}`}
    >
      <div className="flex items-start justify-between mb-6">
        <div
          className="service-icon-wrap w-12 h-12 flex items-center justify-center border border-[#FACC15]/30 transition-colors"
          style={{ background: "rgba(250, 204, 21, 0.05)" }}
        >
          <Icon size={22} color="#FACC15" strokeWidth={1.8} />
        </div>
        <ArrowUpRight
          size={20}
          className="text-white/30 group-hover:text-[#FACC15] transition-colors"
        />
      </div>

      <p className="eyebrow mb-2">{service.featured ? "In evidenza" : `0${index + 1}`}</p>
      <h3
        className={`text-2xl mb-3 font-semibold ${service.featured ? "text-[#FACC15]" : "text-white"}`}
        style={{ fontFamily: "'Outfit', sans-serif" }}
      >
        {service.name}
      </h3>
      <p className="text-white/65 text-sm leading-relaxed flex-1">{service.short}</p>

      <span className="mt-6 text-xs text-[#FACC15] tracking-[0.2em] uppercase font-semibold inline-flex items-center gap-2">
        Scopri di più
        <span className="inline-block w-6 h-px bg-[#FACC15] group-hover:w-10 transition-all duration-300" />
      </span>
    </button>
  );
}
